module.exports = __webpack_public_path__ + "assets/img/btn-detail-55210d30.png";